module.exports = __webpack_public_path__ + "img/stalking-paa-snapchat-2.10cdc42c.png";